import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter,
  get_pinIdAdapter27yg3a7qzsov7 as get_pinIdAdapter,
} from '../../../adapter/Adapter.mjs';
import { list2lpjhmv1d2k19 as list } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SpinInputg1yg8g6z8wv9 as SpinInput } from '../SpinInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SpinInput_InputAdapterClass;
function SpinInput_InputAdapter() {
  if (SpinInput_InputAdapterClass === VOID) {
    class $ {
      z3z(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      j6q(writer, customScalarAdapters, value) {
        writer.c48('partyId');
        get_partyIdAdapter().a40(writer, customScalarAdapters, value.k6p_1);
        writer.c48('playerIds');
        list(get_playerIdAdapter()).h41(writer, customScalarAdapters, value.l6p_1);
        writer.c48('pinIds');
        list(get_pinIdAdapter()).h41(writer, customScalarAdapters, value.m6p_1);
      }
      a40(writer, customScalarAdapters, value) {
        return this.j6q(writer, customScalarAdapters, value instanceof SpinInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SpinInput_InputAdapter', VOID, VOID, [Adapter()]);
    SpinInput_InputAdapterClass = $;
  }
  return SpinInput_InputAdapterClass;
}
var SpinInput_InputAdapter_instance;
function SpinInput_InputAdapter_getInstance() {
  return SpinInput_InputAdapter_instance;
}
//region block: init
SpinInput_InputAdapter_instance = new (SpinInput_InputAdapter())();
//endregion
//region block: exports
export {
  SpinInput_InputAdapter_instance as SpinInput_InputAdapter_instance2oderphk302qf,
};
//endregion

//# sourceMappingURL=SpinInput_InputAdapter.mjs.map
